<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Approve Review Selections" :size="determineSize()">
            <b-container fluid>
                <b-row>
                    <b-col class="registration-info">
                        <b-table-simple hover small responsive bordered>
                            <b-tbody>
                                <b-tr>
                                    <b-td><strong>Company Name:</strong></b-td>
                                    <b-td v-if="selectedRow != '' && !matches">{{ selectedRow.name }}</b-td>
                                    <b-td v-else>{{ row.name }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Resellers Permit:</strong></b-td>
                                    <b-td v-if="selectedRow != '' && !matches">{{ selectedRow.resellers_permit }}</b-td>
                                    <b-td v-else>{{ row.resellers_permit }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Buyers Name:</strong></b-td>
                                    <b-td v-if="selectedRow != '' && !matches">{{ selectedRow.buyers_name }}</b-td>
                                    <b-td v-else>{{ row.buyers_name }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Buyers Contact Number:</strong></b-td>
                                    <b-td v-if="selectedRow != '' && !matches">{{ selectedRow.buyers_contact }}</b-td>
                                    <b-td v-else>{{ row.buyers_contact }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>E-mail:</strong></b-td>
                                    <b-td v-if="selectedRow != '' && !matches">{{ selectedRow.email }}</b-td>
                                    <b-td v-else>{{ row.email }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Address:</strong></b-td>
                                    <b-td v-if="selectedRow != '' && !matches">
                                        {{ selectedRow.address_line_1 }}<br />
                                        <span v-if="selectedRow.address_line_2">{{ selectedRow.address_line_2 }}<br></span>
                                        {{ selectedRow.city }}, {{ selectedRow.state }} {{ selectedRow.zip }}<br>
                                        {{ selectedRow.country }}
                                    </b-td>
                                    <b-td v-else>
                                        {{ row.address_line_1 }}<br />
                                        <span v-if="row.address_line_2">{{ row.address_line_2 }}<br></span>
                                        {{ row.city }}, {{ row.state }} {{ row.zip }}<br>
                                        {{ row.country }}
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Username:</strong></b-td>
                                    <b-td v-if="selectedRow != '' && !matches">{{ selectedRow.username }}</b-td>
                                    <b-td v-else>{{ row.username }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>

                    <b-col class="existing-matches" v-if="matches">
                        <b-table-simple hover small responsive bordered v-if="selectedRow">
                            <b-tbody>
                                <b-tr>
                                    <b-td><strong>Company Name:</strong></b-td>
                                    <b-td>{{ selectedRow.name }}<span class="customer-linked" v-if="selectedRow.username"> (Linked)</span></b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Resellers Permit:</strong></b-td>
                                    <b-td>{{ selectedRow.resellers_permit }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Buyers Name:</strong></b-td>
                                    <b-td>{{ selectedRow.buyers_name }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Buyers Contact Number:</strong></b-td>
                                    <b-td>{{ selectedRow.buyers_contact }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>E-mail:</strong></b-td>
                                    <b-td>{{ selectedRow.email }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Address:</strong></b-td>
                                    <b-td>
                                        {{ selectedRow.billing_address_1 }}<br />
                                        <span v-if="selectedRow.billing_address_2">{{ selectedRow.billing_address_2 }}<br></span>
                                        {{ selectedRow.billing_city }}, {{ selectedRow.billing_state }} {{ selectedRow.billing_postal_code }}<br>
                                        {{ selectedRow.billing_country }}
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><strong>Username:</strong></b-td>
                                    <b-td>{{ selectedRow.username }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </b-container>

            <template #modal-footer="{ cancel, ok }">
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <b-form inline v-if="matches">
                                <label class="mr-sm-2" for="nameSelect">Matches:</label>
                                <b-form-select v-model="selectedId" id="nameSelect" size="sm" value-field="id" text-field="name" :options="row.customers" @change="changeMatch" :disabled="manualCustomerId != '' || createNew" />
                            </b-form>
                        </b-col>
                        <b-col>
                            <b-form inline>
                                <label class="mr-sm-2" for="input-manual-customer-id">Cust ID:</label>
                                <b-form-input class="mb-2 mr-sm-2 mb-sm-0" id="input-manual-customer-id" v-model="manualCustomerId" type="text" autocomplete="off" size="sm" placeholder="" @input="changeMatchId" :disabled="createNew" />
                            </b-form>
                        </b-col>
                        <b-col>
                            <b-form inline>
                                <label class="mr-sm-2" for="checkbox-create-new">Create New:</label>
                                <b-form-checkbox id="checkbox-create-new" v-model="createNew" :value="true" :unchecked-value="false" :disabled="manualCustomerId != ''" />
                            </b-form>
                        </b-col>
                        <b-col class="right-matches">
                            <b-button size="sm" @click="cancel()">
                                Cancel
                            </b-button>
                            <b-button size="sm" variant="success" @click="approve" :disabled="approveCheck()">
                                Approve
                            </b-button>
                        </b-col>
                    </b-row>
                </b-container>
            </template>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: [ 'row', 'matches' ],

		data() {
			return {
				modalName: 'modal-customer-sign-up-review-approve',

                selectedId: [],
                selectedRow: [],
                previousRow: [],
                manualCustomerId: '',
                createNew: false,

                debounceMilliseconds: 500,
                timeout: null,
			}
		},

		methods: {
            determineSize() {
                if (this.matches) {
                    return 'xl'
                } else {
                    // return 'lg'
                    return 'xl'
                }
            },

            approveCheck() {
                if (this.matches) {
                    if (this.selectedRow.username && !this.createNew) {
                        return true
                    }
                } else {
                    if (!this.createNew && !this.manualCustomerId) {
                        return true
                    }
                }

                return false
            },

            approve() {
                this.$emit('approveRow', this.row.id, this.selectedId, this.manualCustomerId, this.createNew)
                this.closeModal(this.modalName)
            },

            changeMatch() {
                let index = this.findIndex(this.row.customers, 'id', this.selectedId)
                this.selectedRow = this.row.customers[index]
                this.previousRow = this.row.customers[index]
            },

            changeMatchId() {
                if (this.manualCustomerId) {
                    clearTimeout(this.timeout)
                    this.timeout = setTimeout(() => {
                        let url = 'api/lists/customers/getcustomer/' + this.manualCustomerId
                        axios.get(url, {})
                        .then((res) => {
                            if (res.data.status == 'success') {
                                if (res.data.customer.username) {
                                    this.showAlertBox('error', 'Error', 'Customer ID already linked. Please unlink.')
                                    this.manualCustomerId = ''

                                    this.selectedRow = this.previousRow
                                } else {
                                    this.selectedRow = res.data.customer
                                }
                            } else {
                                this.showAlertBox('error', 'Error', 'Customer ID Not Found')
                                this.manualCustomerId = ''
                                this.selectedRow = this.previousRow
                            }
                        }, () => {
                            this.has_error = true
                        })
                    }, this.debounceMilliseconds)
                }
            }
		},

        watch: {
            'manualCustomerId': {
				handler(val) {
                    if (val == '') {
                        this.selectedRow = this.previousRow
                    }
                }
            }
        },

        mounted() {
            if (this.matches) {
                this.selectedId = this.row.customers[0].id
                this.selectedRow = this.row.customers[0]
                this.previousRow = this.row.customers[0]
            } else {
                this.createNew = true
            }
        }
	}
</script>

<style lang="scss">
    #modal-customer-sign-up-review-approve {
        .registration-info {
            padding-right: 20px;
        }

        .existing-matches {
            border-left: 1px solid #ccc;
            padding-left: 20px;
        }

        .right-matches {
            text-align: right;
        }

        .customer-linked {
            color: red;
        }
    }
</style>
